<script>
import {mapActions} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import ProposalListItem from "@/components/MainSearch/SearchResult/Proposal/ProposalListItem.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";

export default {
  name: "OrgProfileProposalsList",
  components: {
    ProposalListItem,
    BaseNoResultMessage,
    InfiniteLoadingLoader
  },
  data() {
    return {
      searchParams: {
        proposerId: this.$route.params.id,
        proposerType: 'ORGANIZATION',
        page: 1,
        size: 10,
      },
      proposalsList: [],
      lastItems: false
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'getProposalsAction'
    ]),
    infiniteHandler($state) {
      if ($state) {
        this.getProposals($state);
      }
    },
    getProposals($state) {
      if (!this.lastItems) {
        this.getProposalsAction(this.searchParams).then((resp) => {
          this.proposalsList = this.proposalsList.concat(resp.data.content);
          this.searchParams.page += 1;
          this.lastItems = resp.data.numberOfElements < this.searchParams.size;

          if ($state) {
            if (this.proposalsList.length === 0) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        });
      } else {
        $state.complete();
      }
    }
  }
}
</script>

<template>
  <div class="profile-proposals-list">
    <proposal-list-item v-for="item in proposalsList"
                        :key="item.id"
                        :item-data="item"
    />
    <infinite-loading @infinite="infiniteHandler">
      <template #spinner>
        <InfiniteLoadingLoader v-if="!lastItems"/>
      </template>
      <template #no-more>
        <div></div>
      </template>
      <template #no-results>
        <base-no-result-message :text="$t('profile.noProposals')"/>
      </template>
    </infinite-loading>
  </div>
</template>